import React from 'react';
import { Link, Progress, Table } from '@backstage/core-components';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { useRepository, useTags } from '../../hooks/quay.esm.js';
import { useQuayViewPermission } from '../../hooks/useQuayViewPermission.esm.js';
import PermissionAlert from '../PermissionAlert/PermissionAlert.esm.js';
import { useStyles, columns } from './tableHeading.esm.js';

function QuayRepository(_props) {
  const { repository, organization } = useRepository();
  const classes = useStyles();
  const configApi = useApi(configApiRef);
  const quayUiUrl = configApi.getOptionalString("quay.uiUrl");
  const hasViewPermission = useQuayViewPermission();
  const title = quayUiUrl ? /* @__PURE__ */ React.createElement(React.Fragment, null, `Quay repository: `, /* @__PURE__ */ React.createElement(
    Link,
    {
      to: `${quayUiUrl}/repository/${organization}/${repository}`
    },
    `${organization}/${repository}`
  )) : `Quay repository: ${organization}/${repository}`;
  const { loading, data } = useTags(organization, repository);
  if (!hasViewPermission) {
    return /* @__PURE__ */ React.createElement(PermissionAlert, null);
  }
  if (loading) {
    return /* @__PURE__ */ React.createElement("div", { "data-testid": "quay-repo-progress" }, /* @__PURE__ */ React.createElement(Progress, null));
  }
  return /* @__PURE__ */ React.createElement("div", { "data-testid": "quay-repo-table" }, /* @__PURE__ */ React.createElement(
    Table,
    {
      title,
      options: { sorting: true, paging: true, padding: "dense" },
      data,
      columns,
      emptyContent: /* @__PURE__ */ React.createElement("div", { "data-testid": "quay-repo-table-empty", className: classes.empty }, "There are no images available.")
    }
  ));
}

export { QuayRepository };
//# sourceMappingURL=QuayRepository.esm.js.map
